import Swiper from 'swiper/bundle';

export default class BedCollectionsSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-bed-collections-swiper')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            new Swiper(".js-bed-collections-swiper", {
                slidesPerView: 1,
                spaceBetween: 16,
                pagination: {
                    el: ".swiper-pagination",
                    type: "progressbar",
                },
                breakpoints: {
                    640: {
                      slidesPerView: 2,
                    },
                    1280: {
                      slidesPerView: 3,
                    },
                }
            });
        }

    }

};

new BedCollectionsSlider();